<template>
	<v-dialog v-model="dialog" max-width="450px" hide-overlay>
		<template v-slot:activator="{ on }">
			<v-btn color="secondary" icon v-on="on">
				<v-tooltip bottom color="primary">
					<template v-slot:activator="{ on }">
						<v-icon small v-on="on">mdi-delete</v-icon>
					</template>
					<span>{{'delete channel' | localize}}</span>
				</v-tooltip>
			</v-btn>
		</template>
		<v-card v-if="!loading" >
			<v-divider></v-divider>
			<v-card-title class="subtitle-1 pt-6 text-pre-wrap">
				{{'Would you like to delete the channel' | localize}} <span class="secondary--text">{{ this.channel.name }}</span> ? &#129300;
			</v-card-title>
			<v-divider></v-divider>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn color="error" text
					class="text-capitalize"
					@click="deleteChannel">
					{{'Yes' | localize }}
				</v-btn>
				<v-btn color="secondary" text
					class="text-capitalize"
					@click="closeDialog">
					{{'No' | localize }}
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import { retailInvestments } from '../../../functions/retail';
	export default {
		props: ['channel'],
		data () {
			return	{
				dialog: false
			}
		},
		computed: {
			loading () {
				return this.$store.getters.loading;
			},
			locale () {
				return this.$store.getters.locale;
			},
			intermediary() {
				return this.$store.getters.intermediary;
			}
		},
		methods: {
			async deleteChannel () {
				
				if (this.channel.round !== this.channel.register_round) {
					//calculate - investments
					const retail_writte_off = retailInvestments(this.channel.type, this.channel.stores);
					//update intermediary
					const interdto = { 
						id: this.intermediary.id, 
						retail_writte_off: this.intermediary.retail_writte_off + retail_writte_off 
					}
					try {
						await this.$store.dispatch('updateIntermediary', interdto);	
					}
					catch(error) {
						await this.$store.dispatch('setError', `Updating intermediary error: ${error.message}`);	
					}
				}
				//dalete channel
				try {
					await this.$store.dispatch('deleteChannel', this.channel.id);
				}
				catch(error) {
					await this.$store.dispatch('setError', `Deleting channel error: ${error.message}`);
				}
				
				this.closeDialog ()				
			},
			closeDialog () {
				//reset
				this.dialog = false
			}
		},
	}
</script>
